//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      Cpu: [
        {
          value: '1核',
          name: '1核',
        },
        {
          value: '2核',
          name: '2核',
        },
        {
          value: '4核',
          name: '4核',
        },
        {
          value: '8核',
          name: '8核',
        },
        {
          value: '16核',
          name: '16核',
        }
      ],
      Ram:[
        {
          value: '1G',
          name: '1G'
        },
        {
          value: '2G',
          name: '2G'
        },
        {
          value: '4G',
          name: '4G'
        },
        {
          value: '8G',
          name: '8G'
        },
      ],
      shengjiForm:{
        cpu:['1核'],
        ram:['1G'],
        ssd:Number,
        net:Number,
        money:'',
        coupon:[],
        price:''
      },
    }
  },
  created() {
    this.shengjiForm.cpu[0] = this.$route.params.cpu + '核'
    this.shengjiForm.ram[0] = this.$route.params.ram + 'G'
    this.shengjiForm.ssd = Number(this.$route.params.ssd)
    this.shengjiForm.net = Number(this.$route.params.net)
  },
  computed: {
    cpu() {
      return this.shengjiForm.cpu[0]
    },
    ram() {
      return this.shengjiForm.ram[0]
    },
    ssd() {
      return this.shengjiForm.ssd
    },
    net() {
      return this.shengjiForm.net
    }
  },
  watch:{
    cpu(val,oldval){
      if(val === '1核'){
        this.Ram = [
          {
            value: '1G',
            name: '1G'
          },
          {
            value: '2G',
            name: '2G'
          },
          {
            value: '4G',
            name: '4G'
          },
          {
            value: '8G',
            name: '8G'
          }
        ]
      }
      if(val === '2核'){
        this.Ram = [
          {
            value: '2G',
            name: '2G'
          },
          {
            value: '4G',
            name: '4G'
          },
          {
            value: '8G',
            name: '8G'
          },
          {
            value: '16G',
            name: '16G'
          }
        ]
      }
      if(val === '4核'){
        this.Ram = [
          {
            value: '4G',
            name: '4G'
          },
          {
            value: '8G',
            name: '8G'
          },
          {
            value: '16G',
            name: '16G'
          },
          {
            value: '32G',
            name: '32G'
          }
        ]
      }
      if(val === '8核'){
        this.Ram = [
          {
            value: '8G',
            name: '8G'
          },
          {
            value: '16G',
            name: '16G'
          },
          {
            value: '32G',
            name: '32G'
          },
          {
            value: '64G',
            name: '64G'
          }
        ]
      }
      if(val === '16核'){
        this.Ram = [
          {
            value: '16G',
            name: '16G'
          },
          {
            value: '32G',
            name: '32G'
          },
          {
            value: '64G',
            name: '64G'
          }
        ]
      }
      if(oldval != '' && val != ''){
        this.shengjiForm.ram[0] = this.Ram[0].value
        this.levelPrice()
      }
    },
    ram(val,oldval){
      this.levelPrice()
    },
    ssd(val,oldval){
      this.levelPrice()
    },
    net(val,oldval){
      this.levelPrice()
    },
  },
  mounted(){
    this.config()
  },
  methods: {
    async config() {
      this.couponInfo()
    },
    async couponInfo() {
      this.$http.post('https://api.abeiyun.com/www/user.php','cmd=userinfo').then(({data})=>{
        if(data.response == 200) {
          this.shengjiForm.money = data.msg.money
          let onuse = data.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              name: '(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.shengjiForm.yhq = onuse.filter(items => {
            return items.yhq_use === '续费'
          })
          this.shengjiForm.yhq.unshift({
            value: '',
            name: '不使用优惠券',
            yhq_use: ''
          })
        }
      })
    },
    async levelPrice() {
      this.shengjiForm.price = '价格计算中...'
      let data = 'cmd=vps_price'+
        '&yewu_id='+ this.$route.params.id +
        '&CPU='+ this.shengjiForm.cpu[0].replace('核','') +
        '&RAM='+ this.shengjiForm.ram[0].replace('G','') +
        '&SSD='+ this.shengjiForm.ssd +
        '&NET_WIDTH='+ this.shengjiForm.net +
        '&yhq_id='+ this.shengjiForm.coupon
      await this.$http.post('https://api.abeiyun.com/www/upgrade.php',data).then(({data})=>{
        if(data.response == 200){
          this.shengjiForm.pset = data.pset
          this.shengjiForm.price = data.msg
        }else if(data.msg === '当前配置没有更改！'){
          this.shengjiForm.price = 0
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
    async Level() {
      let data = 'cmd=vps_upgrade'+
        '&yewu_id='+ this.$route.params.id +
        '&CPU='+ this.shengjiForm.cpu[0].replace('核','') +
        '&RAM='+ this.shengjiForm.ram[0].replace('G','') +
        '&SSD='+ this.shengjiForm.ssd +
        '&NET_WIDTH='+ this.shengjiForm.net +
        '&yhq_id='+ this.shengjiForm.coupon
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/upgrade.php',data).then(({data})=>{
        if(data.response == 200){
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/serverlevel.vue